var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ClientProvider } from './ClientProvider';
import axios from 'axios';
var AxiosClient = /** @class */ (function (_super) {
    __extends(AxiosClient, _super);
    function AxiosClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AxiosClient.prototype.generic = function (parameters) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = parameters.url, methodType = parameters.methodType, headers = parameters.headers, query = parameters.query, payload = parameters.payload;
            if (query) {
                url = encodeURI(url) + _this.appendQuery(query);
            }
            else {
                url = encodeURI(url);
            }
            var method = (methodType ? methodType : 'POST');
            // axios request options like headers etc
            var options = {
                headers: headers,
                url: url,
                data: payload,
                method: method,
            };
            axios(options)
                .then(function (response) {
                resolve(response.data);
            })
                .catch(function (response) {
                reject(response);
            });
        });
    };
    AxiosClient.prototype.get = function (parameters) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // extract the individual parameters
            var url = parameters.url, methodType = parameters.methodType, headers = parameters.headers, query = parameters.query;
            if (query) {
                url = encodeURI(url) + _this.appendQuery(query);
            }
            else {
                url = encodeURI(url);
            }
            // axios request options like headers etc
            var options = {
                headers: headers,
            };
            // finally execute the GET request with axios:
            axios
                .get(url, options)
                .then(function (response) {
                resolve(response.data);
            })
                .catch(function (response) {
                reject(response);
            });
        });
    };
    AxiosClient.prototype.post = function (parameters) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = parameters.url, methodType = parameters.methodType, headers = parameters.headers, query = parameters.query, payload = parameters.payload;
            if (query) {
                url = encodeURI(url) + _this.appendQuery(query);
            }
            else {
                url = encodeURI(url);
            }
            // axios request options like headers etc
            var options = {
                headers: headers,
            };
            // finally execute the POST request with axios:
            axios
                .post(url, payload, options)
                .then(function (response) {
                resolve(response.data);
            })
                .catch(function (response) {
                reject(response);
            });
        });
    };
    return AxiosClient;
}(ClientProvider));
export { AxiosClient };
//# sourceMappingURL=AxiosClient.js.map